module.exports = __webpack_public_path__ + "static/interlock-6acbe365811ce6dfe0d407ff5478492b.jpg";